$(document).ready(function () {
  // Smooth scroll when clicking elements with class .goto_div
  $(".goto_div").click(function (e) {
    e.preventDefault();
    var this_id = $(this).attr("data-id");
    var toppos2 = $("#" + this_id).offset().top;
    $("html, body").stop().animate({ scrollTop: toppos2 }, 800, "swing");
  });

  // Scroll event to toggle active class & show/hide images based on scroll position
  $(window).scroll(function () {
    var wsc = $(window).scrollTop();

    $(".growth_mkt_wrap .left_wrap .title_wrap_desktop").each(function () {
      var $this = $(this);
      var offset_plus=45;
      var toppos = $this.offset().top - $this.innerHeight() * 2.8 + offset_plus;
      var nextEle = $this.next();
      if (nextEle.length) {
        var nextEleTop = nextEle.offset().top;
        if (wsc > toppos && wsc < nextEleTop) {
          $(".growth_mkt_wrap .left_wrap .title_wrap_desktop").removeClass("active");
          $this.addClass("active");

          var classname = $this.attr("data-homeclass");
          $(".growth_mkt_wrap .right_wrap .slider_hori").hide();
          $(".growth_mkt_wrap .right_wrap ." + classname).show();
        }
      } else {
        if (wsc > toppos) {
          $(".growth_mkt_wrap .left_wrap .title_wrap_desktop").removeClass("active");
          $this.addClass("active");

          var classname = $this.attr("data-homeclass");
          $(".growth_mkt_wrap .right_wrap .slider_hori").hide();
          $(".growth_mkt_wrap .right_wrap img." + classname).show();
        }
      }
    });
  });

  // Tabs click handler
  $(".tabs li").click(function () {
    var tab_id = $(this).attr("data-tab");
    $(".tab-content").removeClass("active-tab");
    $(".tabs li").removeClass("active-tab");
    $("#tab-" + tab_id).addClass("active-tab");
    $(this).addClass("active-tab");
  });

  // Growth market sustainability section click handler
  $(".growth_mkt_wrap_sustainability .title_wrap_desktop").click(function () {
    var tab_id = $(this).attr("data-set");
    $(".growth_mkt_wrap_sustainability .title_wrap_desktop").removeClass("active");
    $(this).addClass("active");
    $(".growth_mkt_wrap_sustainability .rrc").hide();
    $("#" + tab_id).fadeIn(600);
  });

  // Manual drawer open/close handlers
  $('.manual_drawer[data-action="open-drawer"]').click(function () {
    var id = $(this).attr("data-drawer-id");
    $("#" + id).attr("aria-hidden", "false");
    $(".PageOverlay").addClass("is-visible");
  });

  $("#sidebar-clinical .Drawer__Close").click(function () {
    $(".manual_drawer_pop").attr("aria-hidden", "true");
    $(".PageOverlay").removeClass("is-visible");
  });

  $("#sidebar-supplement .Drawer__Close").click(function () {
    $(".manual_drawer_pop").attr("aria-hidden", "true");
    $(".PageOverlay").removeClass("is-visible");
  });

  // Slideshow wrap setup
  var $slideshow = $(".Product__Slideshow"),
    $mobileNav = $(".Product__SlideshowMobileNav");

  if ($slideshow.length && $mobileNav.length) {
    $slideshow.add($mobileNav).wrapAll('<div class="Product__SlideshowWrapperParent"></div>');
  }

  // Scroll left_right_wrap_parent_wrap horizontally on clicking specific buttons
  $(".sci_a, .clear_a, .Meas_a").on("click", function () {
    var position = 1;
    if ($(this).hasClass("clear_a")) position = 2;
    else if ($(this).hasClass("Meas_a")) position = 3;

    var sl = $(".growth_mkt_wrap.inner_mob .left_right_wrap_parent_wrap").scrollLeft();
    var pos = $(".growth_mkt_wrap.inner_mob .left_right_wrap_parent_wrap .left_right_wrap:nth-child(" + position + ")").offset().left;

    $(".growth_mkt_wrap.inner_mob .left_right_wrap_parent_wrap").animate(
      {
        scrollLeft: sl + pos - 20 + "px",
      },
      500
    );
  });

  // ----------- NEW: Super slow & smooth mouse wheel horizontal scroll -----------
  var $scrollSection = $(".growth_mkt_wrap.inner_mob .left_right_wrap_parent_wrap");
  var isAnimating = false;
  var targetScrollLeft = $scrollSection.scrollLeft();

  var scrollSpeed = 0.05; // VERY slow scroll speed

  $scrollSection.on("wheel", function (e) {
    e.preventDefault();

    var delta = e.originalEvent.deltaY || e.originalEvent.wheelDelta;

    targetScrollLeft += delta * scrollSpeed;

    // Clamp the target scroll position within valid scroll range
    var maxScrollLeft = $scrollSection[0].scrollWidth - $scrollSection.outerWidth();
    if (targetScrollLeft < 0) targetScrollLeft = 0;
    if (targetScrollLeft > maxScrollLeft) targetScrollLeft = maxScrollLeft;

    if (!isAnimating) {
      isAnimating = true;
      smoothScroll();
    }
  });

  function smoothScroll() {
    var currentScrollLeft = $scrollSection.scrollLeft();
    var diff = targetScrollLeft - currentScrollLeft;

    if (Math.abs(diff) > 0.5) {
      $scrollSection.scrollLeft(currentScrollLeft + diff * 0.05); // slow easing factor
      requestAnimationFrame(smoothScroll);
    } else {
      $scrollSection.scrollLeft(targetScrollLeft);
      isAnimating = false;
    }
  }
});
